var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34987 9.49864L5.99284 11.8557C5.02057 12.8279 3.42958 12.8279 2.45731 11.8557C1.48504 10.8834 1.48504 9.2924 2.45731 8.32012L4.81433 5.9631L3.63582 4.78459L1.2788 7.14161C-0.347548 8.76796 -0.347548 11.4078 1.2788 13.0342C2.90514 14.6605 5.54501 14.6605 7.17135 13.0342L9.52838 10.6771L8.34987 9.49864ZM7.17141 1.249L4.81439 3.60602L5.9929 4.78453L8.34992 2.42751C9.32219 1.45524 10.9132 1.45524 11.8855 2.42751C12.8577 3.39978 12.8577 4.99077 11.8855 5.96304L9.52843 8.32007L10.7069 9.49858L13.064 7.14155C14.6903 5.51521 14.6903 2.87534 13.064 1.249C11.4376 -0.377346 8.79776 -0.377346 7.17141 1.249ZM8.93912 4.19535L4.22508 8.9094L5.40359 10.0879L10.1176 5.37386L8.93912 4.19535Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.4d6ebf84.svg";
export { ForwardRef as ReactComponent };